export var DEFAULT = 'default';
export var NUMBER = 'number';
export var TEXT = 'text';
export var CHECKBOX = 'checkbox';
export var DATE = 'date';
export var SINGLE_SELECT = 'single-select';
export var LONG_TEXT = 'long-text';
export var IMAGE = 'image';
export var FILE = 'file';
export var MULTIPLE_SELECT = 'multiple-select';
export var COLLABORATOR = 'collaborator';
export var LINK = 'link';
export var FORMULA = 'formula';
export var LINK_FORMULA = 'link-formula';
export var CREATOR = 'creator';
export var CTIME = 'ctime';
export var LAST_MODIFIER = 'last-modifier';
export var MTIME = 'mtime';
export var GEOLOCATION = 'geolocation';
export var AUTO_NUMBER = 'auto-number';
export var URL = 'url';
export var EMAIL = 'email';
export var DURATION = 'duration';
export var BUTTON = 'button';
export var RATE = 'rate';

// formula | link-formula column calculate result type
export var BOOL = 'bool';
export var STRING = 'string';